// @ts-nocheck

import { createSelector } from 'reselect';

import { selectFlashMessages } from '../../selectors/flashmessages/flashmessagesPrimary.selector';
import { type FlashMessages } from '../../states/flashmessages';
import { type Selector } from '../../types/selectors';

type FlashMessagesListPropsType = {
  flasMessages: FlashMessages;
};

const selectFlashMessagesListProps: Selector<FlashMessagesListPropsType> = createSelector(
  [selectFlashMessages],
  (flashMessages) => ({
    flashMessages,
  }),
);

export default selectFlashMessagesListProps;
